"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useProductPatameters = _interopRequireDefault(require("@sprinx/react-products/useProductPatameters"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useFilterFieldOptions = _interopRequireDefault(require("../useFilterFieldOptions"));

//
function FilterFieldParameter(_ref) {
  var buildFilter = _ref.buildFilter,
      Component = _ref.Component,
      field = _ref.field,
      filter = _ref.filter,
      filterValue = _ref.filterValue,
      pLabel = _ref.label,
      onChange = _ref.onChange,
      parameterName = _ref.parameterName,
      parentFilter = _ref.parentFilter,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buildFilter", "Component", "field", "filter", "filterValue", "label", "onChange", "parameterName", "parentFilter"]);
  var t = (0, _useTranslate.default)();

  var _useProductParameters = (0, _useProductPatameters.default)(),
      _useProductParameters2 = (0, _slicedToArray2.default)(_useProductParameters, 1),
      parameters = _useProductParameters2[0];

  var parameter = parameters.find(function (p) {
    return p.code === parameterName;
  });

  var strategy = _react.default.useMemo(function () {
    return ['parameter', parameterName];
  }, [parameterName]);

  var filterFieldOptions = (0, _useFilterFieldOptions.default)({
    buildFilter: buildFilter,
    field: field,
    filter: filter,
    parentFilter: parentFilter,
    strategy: strategy
  });
  var fieldValue = filterValue && filterValue[field] || null;
  var label = pLabel || parameter && parameter.label || parameterName;

  var opts = _react.default.useMemo(function () {
    // const { options = [] } = filterFieldOptions;
    var options = filterFieldOptions || [];
    return options.map(function (_ref2) {
      var count = _ref2.count,
          value = _ref2.value;
      return {
        count: count,
        value: value,
        label: (parameter && parameter.enum && parameter.enum.find(function (i) {
          return i.code === value;
        }) || {}).label || (value === true ? t('parameters/yes') : value)
      };
    }).filter(function (i) {
      return Boolean(i.label);
    });
  }, [filterFieldOptions, parameter, t]);

  var handleChange = _react.default.useCallback(function (v) {
    return onChange({
      field: field,
      value: v && v.length > 0 ? v : undefined
    });
  }, [field, onChange]);

  return opts.length ? /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    options: opts,
    onChange: handleChange,
    label: label,
    value: fieldValue
  }, rest)) : null;
}

process.env.NODE_ENV !== "production" ? FilterFieldParameter.propTypes = {
  buildFilter: _propTypes.default.func.isRequired,
  Component: _propTypes.default.elementType.isRequired,
  field: _propTypes.default.string.isRequired,
  filter: _propTypes.default.shape({}),
  filterValue: _propTypes.default.shape({}),
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  parameterName: _propTypes.default.string.isRequired,
  parentFilter: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.arrayOf(_propTypes.default.shape({}))])
} : void 0;
FilterFieldParameter.defaultProps = {
  filter: undefined,
  filterValue: undefined,
  label: undefined,
  parentFilter: undefined
};
var _default = FilterFieldParameter;
exports.default = _default;